import { alertVariants } from "@visiblethread/react-components";
import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import { modalTypes } from "constants/types";
import { useEffect } from "react";
import { useDispatch, useStore } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { showGlobalAlert } from "slices/app/appSlice";
import { getCollections } from "slices/collections/actions";
import { setSelected } from "slices/collections/collectionsSlice";
import { selectCurrentContractId } from "slices/contracts/detail/selectors";
import { getDocuments } from "slices/documentUploads/actions";
import { selectCurrentMiscAnalysisId } from "slices/miscAnalysis/selectors";
import { selectOpportunityId } from "slices/opportunity/summary/selectors";
import { selectProposalId } from "slices/proposals/proposal/selectors";
import { fetchDocumentStyleTemplates } from "slices/settings/actions/addInSettings";
import { setActiveSource } from "slices/workspace/chooseFilesModalSlice";

import { FILE_SOURCES } from "../../layout/documentUploader/constants";
import { getSharepointAuthRedirect } from "../../slices/sharepoint/actions";

const ENTITY_ID_SELECTORS = {
  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: selectOpportunityId,
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: selectProposalId,
  [UPLOAD_ENTITY_TYPES.CONTRACT]: selectCurrentContractId,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]: selectCurrentMiscAnalysisId,
};

const handleChooseFilesReturn = async (dispatch, store, savedState) => {
  const { target, hadLocalFiles, selectedCollectionId } = savedState;

  const entityIdSelector = ENTITY_ID_SELECTORS[target];

  dispatch(setActiveSource(FILE_SOURCES.SHAREPOINT));

  if (target === UPLOAD_ENTITY_TYPES.COLLECTIONS && selectedCollectionId) {
    await dispatch(getCollections());
    const collection = (store.getState().collections?.list || []).find(
      (c) => c.id === selectedCollectionId
    );
    if (collection) {
      dispatch(setSelected(collection));
    }
  }

  dispatch(
    showModal(modalTypes.CHOOSE_FILES, {
      target,
      onFilesUploaded: () => {
        if (target === UPLOAD_ENTITY_TYPES.DOC_STYLE_TEMPLATES) {
          dispatch(fetchDocumentStyleTemplates());
          return;
        }

        if (entityIdSelector) {
          const entityId = entityIdSelector(store.getState());

          if (entityId) {
            dispatch(getDocuments(entityId, target));
          }
        }
      },
    })
  );

  if (hadLocalFiles) {
    dispatch(
      showGlobalAlert({
        variant: alertVariants.information,
        text: "Connected to SharePoint. Please re-select any local files you had previously chosen.",
      })
    );
  }
};

const handleCollectionsReturn = async (dispatch) => {
  await dispatch(getCollections());
  dispatch(showModal(modalTypes.COLLECTIONS_MODAL));
};

const useSharepointAuthReturn = () => {
  const dispatch = useDispatch();
  const store = useStore();

  useEffect(() => {
    const savedState = getSharepointAuthRedirect();
    if (!savedState) return;

    if (savedState.source === "COLLECTIONS_MODAL") {
      handleCollectionsReturn(dispatch);
    } else {
      handleChooseFilesReturn(dispatch, store, savedState);
    }
  }, [dispatch, store]);
};

export default useSharepointAuthReturn;
